import {
  AnyCalendarDate,
  CalendarDate,
  GregorianCalendar,
  IslamicTabularCalendar,
  parseDate,
  PersianCalendar,
  toCalendar
} from "@internationalized/date";
import { captureException } from "@sentry/nextjs";
import { DatepickerDateType } from "@website/ui/datepicker";
import {
  DayType,
  gregorianToShamsi,
  MonthType
} from "@website/utils/date-converter";

export const convertDate = (date: DatepickerDateType, toLocale: string) => {
  const newDate = parseDate(date.dateTime);
  let newDateConverted: AnyCalendarDate;

  switch (toLocale) {
    case "persian": {
      // @internationalize/date has issue with
      // convert from gregorian to persian.
      // this code fix that issue.
      // update it later.
      const temporaryDateConverted = gregorianToShamsi(
        newDate.year,
        newDate.month as MonthType,
        newDate.day as DayType
      );
      newDateConverted = new CalendarDate(
        new PersianCalendar(),
        temporaryDateConverted[0],
        temporaryDateConverted[1],
        temporaryDateConverted[2]
      );
      break;
    }
    case "hijri": {
      newDateConverted = toCalendar(newDate, new IslamicTabularCalendar());
      break;
    }
    default: {
      newDateConverted = toCalendar(newDate, new GregorianCalendar());
    }
  }

  return {
    dateTime: date.dateTime,
    year: newDateConverted.year,
    month: newDateConverted.month,
    day: newDateConverted.day
  };
};

export const formatDateToDatepickerDateType = (date: string, local: string) => {
  const dt = new Date(date);
  return convertDate(
    {
      year: dt.getFullYear(),
      month: dt.getMonth() + 1,
      day: dt.getDate(),
      dateTime: date
    },
    local
  );
};

export const convertDateAndTime = (
  date?: string,
  options?: Intl.DateTimeFormatOptions
) => {
  if (date) {
    try {
      return new Intl.DateTimeFormat("fa-IR", options).format(new Date(date));
    } catch (error) {
      captureException(`convertDateAndTime + ${error}`);
    }
  }
  return "";
};
